import {createApi} from '@reduxjs/toolkit/query/react';

import {apiQuery} from './api-query';

// this is the base API, extended by all other specific APIs
// https://redux-toolkit.js.org/tutorials/rtk-query#create-an-api-service
export const sweetAPI = createApi({
  reducerPath: 'sweetAPI',
  baseQuery: apiQuery,
  endpoints: () => ({}),
  // always fetch data on mount (except the same request was made less than 1 sec ago)
  // i.e. when two components are mounted and fetch the same API with same args
  // https://redux-toolkit.js.org/rtk-query/usage/cache-behavior#encouraging-re-fetching-with-refetchonmountorargchange
  refetchOnMountOrArgChange: 1,

  // keep cache for 8 hours after no bodody is using it (in the old days we kept it forever)
  keepUnusedDataFor: 8 * 3600,
});
